import { ScopeTypeId as ScopeTypeId$1, CloseableScopeTypeId as CloseableScopeTypeId$1, scopeAddFinalizer, scopeAddFinalizerExit, scopeClose, scopeFork } from '../../internal/core.esm.js';
import { scopeTag, scopeExtend, scopeUse, scopeMake } from '../../internal/fiberRuntime.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const ScopeTypeId = ScopeTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const CloseableScopeTypeId = CloseableScopeTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category context
 */
const Scope = scopeTag;

/**
 * @since 2.0.0
 */

/**
 * Adds a finalizer to this scope. The finalizer is guaranteed to be run when
 * the scope is closed.
 *
 * @since 2.0.0
 * @category utils
 */
const addFinalizer = scopeAddFinalizer;

/**
 * A simplified version of `addFinalizerWith` when the `finalizer` does not
 * depend on the `Exit` value that the scope is closed with.
 *
 * @since 2.0.0
 * @category utils
 */
const addFinalizerExit = scopeAddFinalizerExit;

/**
 * Closes a scope with the specified exit value, running all finalizers that
 * have been added to the scope.
 *
 * @since 2.0.0
 * @category destructors
 */
const close = scopeClose;

/**
 * Extends the scope of an `Effect` workflow that needs a scope into this
 * scope by providing it to the workflow but not closing the scope when the
 * workflow completes execution. This allows extending a scoped value into a
 * larger scope.
 *
 * @since 2.0.0
 * @category utils
 */
const extend = scopeExtend;

/**
 * Forks a new scope that is a child of this scope. The child scope will
 * automatically be closed when this scope is closed.
 *
 * @since 2.0.0
 * @category utils
 */
const fork = scopeFork;

/**
 * Uses the scope by providing it to an `Effect` workflow that needs a scope,
 * guaranteeing that the scope is closed with the result of that workflow as
 * soon as the workflow completes execution, whether by success, failure, or
 * interruption.
 *
 * @since 2.0.0
 * @category destructors
 */
const use = scopeUse;

/**
 * Creates a Scope where Finalizers will run according to the `ExecutionStrategy`.
 *
 * If an ExecutionStrategy is not provided `sequential` will be used.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = scopeMake;

export { CloseableScopeTypeId, Scope, ScopeTypeId, addFinalizer, addFinalizerExit, close, extend, fork, make, use };
